import { render, staticRenderFns } from "./EditorPlayerToolbar.vue?vue&type=template&id=6a36a22d&"
import script from "./EditorPlayerToolbar.vue?vue&type=script&lang=js&"
export * from "./EditorPlayerToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports